<div class="file-upload-form-field" [ngStyle]="{ 'max-width': maxWidth() }">
  <div class="file-upload-container">
    <div>

   
    <!-- Label -->
    <p *ngIf="label()" class="file-upload-label">
      {{ label() }}
    </p>
    <p *ngIf="!label()"  class="accepted-formats bold">
      Document Types Accepted: {{ acceptedFormats().join(', ') }}
    </p>

    <!-- Drop area -->
    <div
      class="drop-area"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)"
    >
      <p>{{ placeholder() }}</p>
      <input
        type="file"
        [id]="controlName"
        [multiple]="multiple()"
        (change)="onFileSelected($event)"
        hidden
        [disabled]="control.disabled"
      />
      <label [for]="controlName" class="btn-secondary w-fit">File Upload</label>
    </div>

    <!-- Error message -->
    <p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>

    <!-- Form control errors -->
    <div *ngIf="showError" class="error-message">
      <span *ngIf="control?.hasError('required')">File Required</span>
      <span *ngIf="control?.hasError('message')">
        {{ control.getError('message') }}
      </span>
    </div>
  </div>

  <div class="ml-4">
    <ul *ngIf="files.length > 0" class="file-list">
      <li *ngFor="let file of files; let i = index">
        {{ file.name }}
        <lib-button
          [cssType]="'btn-icon'"
          [icon]="'trash'"
          [size]="'small'"
          (click)="removeFile(i)"
          [disabled]="control.disabled"
        >
        </lib-button>
      </li>
    </ul>
  </div>
    <!-- File list -->
  </div>
</div>